<template>
  <section>
    <z-dialog :show="isVisible" :modal-size="modalSize">
      <template #header>
        <div class="row custom-header">
          <div class="col">
            <h4 class="modal-title">
              {{ title }}
            </h4>
            <span><span v-if="subtitle !== null">for</span> {{ subtitle }}</span>
          </div>
          <div class="col-1">
            <a href="#" class="custom-close" @click="close">
              <i class="fa fa-times"></i>
            </a>
          </div>
        </div>
      </template>
      <template #body>
        <div class="custom-body">
          <p>{{ notice }}</p>
          <div class="row">
            <div class="col">
              <label v-if="isAdd" for="makeLookup">Make(s):<span class="text-danger">*</span></label>
              <Multiselect v-if="isAdd" ref="searchMakes" v-model="makes" class="form-control custom-multiselect"
                placeholder="choose make(s)" :open-direction="'bottom'" :options="lookups['VehicleMake']" mode="tags"
                label="name" value-prop="value" @select="isSave = true" />
              <z-select v-else v-model="make" label="Make" name="make" :options="lookups['VehicleMake']"
                :required="true" @change="isSave = true" />
            </div>
            <div class="col-2">
              <z-select v-model="yearStart" label="Year Start" :options="years" :required="true"
                @change="isSave = true" />
            </div>
            <div class="col-2">
              <z-select v-model="yearEnd" label="Year End" :options="years" :required="true" @change="isSave = true" />
            </div>
            <div class="col-2">
              <z-input v-model="sort" label="Sort" type="number" min="0" name="sort" :add-class="'text-right'"
                @keyup="isSave = true" @change="isSave = true" />
            </div>
            <div class="col"></div>
          </div>
          <div class="row">
            <div class="col-10">
              <z-input v-model="keywords" :label="keywordLabel" :maxlength="1000" :required="true"
                @keyup="isSave = true" />
            </div>
            <div class="col-2 custom-value-wrapper">
              <input v-model="isInactive" class="custom-checkbox ml-2" type="checkbox" @change="isSave = true" />
              <span class="ms-2">Inactive?</span>
            </div>
          </div>
          <div v-if="lookupType === 2 || lookupType === 4" class="row">
            <div class="col-10">
              <z-input v-model="url" label="Url" name="url" :required="true" @keyup="isSave = true" />
            </div>
          </div>
          <div v-if="lookupType === 2 || lookupType === 4" class="row">
            <div class="col-12">
              <z-input v-model="details" label="Details" name="details" :maxlength="1000" @keyup="isSave = true" />
            </div>
            <div class="col-12 mt-2">
              <input v-model="isReport" class="custom-checkbox ms-2" type="checkbox" @change="isSave = true" />
              <span class="ms-2">Add to Scanning Requirements Section on the Report</span>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="row custom-footer">
          <div class="col-1">
            <span>{{ id }}</span>
          </div>
          <div class="col">
            <z-message v-model="message" class="alert alert-warning mt-2" />
          </div>
          <div class="col-3 custom-right-align">
            <button type="button" class="btn btn-light" @click="close()">Cancel</button>
            <button type="button" class="btn btn-primary ms-2" :class="{ 'btn-danger': isSave }"
              @click="save()">Save</button>
          </div>
        </div>
      </template>
    </z-dialog>
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { adasmatrixStore } from '@/stores/adasmatrix'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import ZMessage from '@/components/utilities/elements/Message.vue'
import ZInput from '@/components/utilities/elements/Input.vue'
import ZSelect from '@/components/utilities/elements/Select.vue'
import Multiselect from '@vueform/multiselect'
export default {
  name: 'DialogMatrixInfoLookup',
  components: {
    ZDialog,
    ZMessage,
    ZInput,
    ZSelect,
    Multiselect
  },
  props: {
    modelValue: Object
  },
  data() {
    return {
      modalSize: 'modal-md',
      message: '',
      isSave: false,
      makes: []
    }
  },
  mounted() {
    this.isSave = false
    console.log('Make Matrix Shown', this.adasmatrixinfolookup)
    this.makes = []
    setTimeout(() => {
      this.isSave = false
    }, 250)
  },
  emits: ['update:modelValue', 'closing', 'saved'],
  computed: {
    ...mapState(adasmatrixStore, ['lookups', 'adasmatrixinfolookup']),
    isVisible() {
      return this.modelValue !== null
    },
    keywordLabel() {
      let _data = 'Keywords'
      if (this.lookupType === 2 || this.lookupType === 4) {
        _data = 'Description'
      }
      return _data
    },
    lookupType() {
      let _data = null
      if (this.adasmatrixinfolookup !== undefined && this.adasmatrixinfolookup !== null) {
        _data = this.adasmatrixinfolookup.lookupType
      }
      return _data
    },
    id() {
      let _data = null
      if (this.adasmatrixinfolookup !== undefined && this.adasmatrixinfolookup !== null) {
        if (this.adasmatrixinfolookup.adasChecklistMatrixInfoLookup !== null) {
          _data = `# ${this.adasmatrixinfolookup.adasChecklistMatrixInfoLookup}`
        }
      }
      return _data
    },
    title() {
      let _title = 'Editing Matrix Info Lookup'
      if (this.isAdd) {
        _title = 'Add Matrix Info Lookup'
      }
      return _title
    },
    subtitle() {
      let _data = null
      if (this.modelValue) {
        _data = this.modelValue.subtitle
      }
      return _data
    },
    isAdd() {
      let _is = false
      if (this.modelValue) {
        if (this.modelValue.type === 'ADD') {
          _is = true
        }
      }
      return _is
    },
    notice() {
      let _notice = 'Select vehicle make (with range of years) and supply keyword lookups.'
      if (this.lookupType === 2 || this.lookupType === 4) {
        _notice = 'Select vehicle make (with range of years), supply description and url.'
      }
      return _notice
    },
    years() {
      let _data = []
      let now = new Date()
      let nowYear = now.getFullYear()
      let numValues = 6
      let cnt = 0
      for (let idx = numValues; idx > 0; idx--) {
        _data.push({
          id: cnt,
          name: nowYear + idx,
          value: nowYear + idx
        })
        cnt++
      }
      numValues = nowYear - 1980
      for (let idx = numValues; idx > 0; idx--) {
        _data.push({
          id: cnt,
          name: 1980 + idx,
          value: 1980 + idx
        })
      }
      return _data
    },
    yearStart: {
      get() {
        let _data = null
        if (this.adasmatrixinfolookup) {
          _data = this.adasmatrixinfolookup.yearStart
        }
        return _data
      },
      set(value) {
        this.updateAdasMatrixInfoLookup({
          name: 'yearStart',
          value: value
        })
      }
    },
    yearEnd: {
      get() {
        let _data = null
        if (this.adasmatrixinfolookup) {
          _data = this.adasmatrixinfolookup.yearEnd
        }
        return _data
      },
      set(value) {
        this.updateAdasMatrixInfoLookup({
          name: 'yearEnd',
          value: value
        })
      }
    },
    matrixSource: {
      get() {
        let _data = null
        if (this.adasmatrixinfolookup) {
          _data = parseInt(this.adasmatrixinfolookup.source)
        }
        return _data
      },
      set(value) {
        this.updateAdasMatrixInfoLookup({
          name: 'source',
          value: parseInt(value)
        })
      }
    },
    make: {
      get() {
        let _data = null
        if (this.adasmatrixinfolookup) {
          if (this.adasmatrixinfolookup.vehicleMake) {
            _data = this.adasmatrixinfolookup.vehicleMake.toString()
          }
        }
        return _data
      },
      set(value) {
        this.updateAdasMatrixInfoLookup({
          name: 'make',
          value: value
        })
      }
    },
    keywords: {
      get() {
        let _data = ''
        if (this.adasmatrixinfolookup) {
          _data = this.adasmatrixinfolookup.keywords
        }
        return _data
      },
      set(value) {
        this.updateAdasMatrixInfoLookup({
          name: 'keywords',
          value: value
        })
      }
    },
    details: {
      get() {
        let _data = ''
        if (this.adasmatrixinfolookup) {
          _data = this.adasmatrixinfolookup.description
        }
        return _data
      },
      set(value) {
        this.updateAdasMatrixInfoLookup({
          name: 'description',
          value: value
        })
      }
    },
    url: {
      get() {
        let _data = ''
        if (this.adasmatrixinfolookup) {
          _data = this.adasmatrixinfolookup.url
        }
        return _data
      },
      set(value) {
        this.updateAdasMatrixInfoLookup({
          name: 'url',
          value: value
        })
      }
    },
    isInactive: {
      get() {
        let _data = ''
        if (this.adasmatrixinfolookup) {
          _data = this.adasmatrixinfolookup.isInactive
        }
        return _data
      },
      set(value) {
        this.updateAdasMatrixInfoLookup({
          name: 'isInactive',
          value: value
        })
      }
    },
    isReport: {
      get() {
        let _data = ''
        if (this.adasmatrixinfolookup) {
          _data = this.adasmatrixinfolookup.isReportAdd
        }
        return _data
      },
      set(value) {
        this.updateAdasMatrixInfoLookup({
          name: 'isReportAdd',
          value: value
        })
      }
    },
    sort: {
      get() {
        let _data = 0
        if (this.adasmatrixinfolookup) {
          _data = this.adasmatrixinfolookup.sort
        }
        return _data
      },
      set(value) {
        this.updateAdasMatrixInfoLookup({
          name: 'sort',
          value: value
        })
      }
    }
  },
  methods: {
    ...mapActions(adasmatrixStore, ['updateAdasMatrixInfoLookup', 'saveAdasMatrixInfoLookup']),
    close() {
      this.isSave = false
      this.$emit('closing')
    },
    async save() {
      let proceed = true
      this.message = ''
      if (this.isAdd && this.makes.length === 0) {
        proceed = false
        this.message = 'Please select at least one make.'
      }
      if (proceed && this.yearStart === null) {
        proceed = false
        this.message = 'Please select Year Start.'
      }
      if (proceed && this.yearEnd === null) {
        proceed = false
        this.message = 'Please select Year End.'
      }
      if (proceed && this.yearStart > this.yearEnd) {
        proceed = false
        this.message = 'Year Start must be less than or same as Year End.'
      }
      if (proceed && this.yearEnd < this.yearStart) {
        proceed = false
        this.message = 'Year End must be greater than or same as Year Start.'
      }
      if (proceed) {
        if (this.keywords === null) {
          proceed = false
          this.message = `Please provide ${this.keywordLabel}.`
        }
        if (this.keywords.trim() === '') {
          proceed = false
          this.message = `Please provide ${this.keywordLabel}.`
        }
      }
      if (proceed && (this.lookupType === 2 || this.lookupType === 4)) {
        if (this.url === null) {
          proceed = false
          this.message = 'Please provide Url.'
        }
        if (this.url.trim() === '') {
          proceed = false
          this.message = 'Please provide Url.'
        }
      }
      if (proceed) {
        // Save the Make Matrix
        console.log('Saving Matrix Info Lookup', {
          matrix: this.adasmatrixinfolookup,
          makes: this.makes
        })
        if (this.isAdd && this.makes.length > 0) {
          let cnt = 0
          let lookup = JSON.parse(JSON.stringify(this.adasmatrixinfolookup))
          for (let idx = 0; idx < this.makes.length; idx++) {
            const make = this.makes[idx]
            lookup.vehicleMake = make
            console.log('Saving Matrix', lookup)
            await this.saveAdasMatrixInfoLookup(lookup)
            cnt++
          }
          console.log('Saved Matrix Lookups', cnt)
          this.isSave = false
          this.$emit('saved')
        } else if (!this.isAdd) {
          await this.saveAdasMatrixInfoLookup(this.adasmatrixinfolookup)
          this.isSave = false
          this.$emit('saved')
        }
      } else {
        this.message = 'Please fill in all fields.'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}

.custom-close {
  float: right;
  color: #000;
  cursor: pointer;
}

.custom-body {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 500px;
  min-height: 450px;
}

.custom-footer {
  width: 100%;
  display: inline-flex;
}

.custom-right-align {
  text-align: right;
}

.custom-value-wrapper {
  position: relative;
  top: 35px;
}
</style>
